import script from "./property-listing-floor-upload.vue?vue&type=script&lang=ts&setup=true"
export * from "./property-listing-floor-upload.vue?vue&type=script&lang=ts&setup=true"

import "./property-listing-floor-upload.vue?vue&type=style&index=0&id=decb298e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-decb298e"]])

export default __exports__